module.exports = __webpack_public_path__ + "static/img/WechatIMG369.60480fee.jpeg";